import { Variants } from "framer-motion";

// Site genelinde kullanılacak tutarlı Framer Motion animasyonları

// Sayfa giriş animasyonu
export const pageVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.5,
            staggerChildren: 0.2
        }
    }
};

// Kart/Container animasyonu
export const cardVariants = {
    hidden: { opacity: 0, scale: 0.95, y: 30 },
    visible: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 15,
            staggerChildren: 0.1
        }
    }
};

// İllüstrasyon/Resim animasyonu
export const illustrationVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 80,
            damping: 15
        }
    }
};

// Sağdan gelen animasyon
export const slideFromRightVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 80,
            damping: 15
        }
    }
};

// Aşağıdan yukarı
export const slideFromBottomVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 15
        }
    }
};

/** Çıkış tarihleri / fiyat gibi async veri sonrası mount olan bloklar — kendi animate'i olmalı (yoksa opacity:0 kalır) */
export const mountSafeRevealVariants = {
    hidden: { opacity: 0, y: 28 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 18,
            duration: 0.35,
        },
    },
};

// Form container animasyonu
export const formContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.3
        }
    }
};

// Form item animasyonu
export const formItemVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 12
        }
    }
};

// Liste item animasyonu
export const listItemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
        opacity: 1,
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 12
        }
    }
};

// Buton animasyonu
export const buttonVariants = {
    rest: { scale: 1 },
    hover: {
        scale: 1.02,
        transition: {
            type: "spring" as const,
            stiffness: 400,
            damping: 10
        }
    },
    tap: { scale: 0.98 }
};

// Dialog/Modal animasyonu
export const dialogVariants = {
    hidden: {
        opacity: 0,
        scale: 0.8,
        y: -50
    },
    visible: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 300,
            damping: 25
        }
    },
    exit: {
        opacity: 0,
        scale: 0.8,
        y: 50,
        transition: {
            duration: 0.2
        }
    }
};
export const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.2
        }
    }
}
// Fade in animasyonu
export const fadeInVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: "easeOut" as const
        }
    }
};

// Stagger container (çocukları sırayla animasyonlu)
export const staggerContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.2
        }
    }
};

// Grid item animasyonu
export const gridItemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 15
        }
    }
};

// Header animasyonu
export const headerVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 15
        }
    }
};

// Hover efektleri (inline kullanım için)
export const hoverScale = {
    scale: 1.05,
    transition: {
        type: "spring" as const,
        stiffness: 400,
        damping: 10
    }
};

export const hoverScaleSmall = {
    scale: 1.02,
    transition: {
        type: "spring" as const,
        stiffness: 400,
        damping: 10
    }
};

export const tapScale = {
    scale: 0.95
};

export const tapScaleSmall = {
    scale: 0.98
};

// Input focus animasyonu
export const inputFocusAnimation = {
    scale: 1.01,
    borderColor: "rgba(227, 30, 36, 0.3)",
    transition: {
        type: "spring" as const,
        stiffness: 300,
        damping: 20
    }
};

// Input hover animasyonu
export const inputHoverAnimation = {
    scale: 1.005,
    borderColor: "rgba(0, 0, 0, 0.15)",
    transition: {
        type: "spring" as const,
        stiffness: 300,
        damping: 20
    }
};

// ============================================
// MERKEZİ KART ANİMASYON SİSTEMİ
// ============================================
// Tüm kart bileşenleri için tutarlı, yumuşak yüklenme animasyonları
// Sadece fade (opacity) kullanır - scale ve y kullanmaz
// Ortadan genişleme veya hareket efekti yok, sadece yumuşak görünme

/**
 * Ana kart container animasyonu
 * Sadece yumuşak fade-in - scale ve y kullanmaz
 * Ortadan genişleme veya hareket efekti yok
 */
export const productCardVariants: Variants = {
    hidden: { 
        opacity: 0
    },
    visible: { 
        opacity: 1,
        transition: { 
            duration: 0.6,
            ease: [0.22, 1, 0.36, 1], // Çok yumuşak ease-out (cubic-bezier)
            staggerChildren: 0.1 // İçerik için stagger
        }
    }
};

/**
 * Kart içerik animasyonu (başlık, açıklama vb.)
 * Sadece fade-in - scale ve y kullanmaz
 * Stagger efekti için index desteği
 */
export const productCardContentVariants = (index: number = 0): Variants => ({
    hidden: { 
        opacity: 0
    },
    visible: { 
        opacity: 1,
        transition: { 
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1], // Aynı yumuşak easing
            delay: index * 0.1 + 0.15 // Stagger delay
        }
    }
});

// ============================================
// GERİYE UYUMLULUK İÇİN ALİAS'LAR
// ============================================
// Mevcut kodları bozmamak için eski isimleri de export ediyoruz
export const tourCardVariants = productCardVariants;
export const tourContentVariants = productCardContentVariants;

export const tourHoverVariants: Variants = {
    rest: { scale: 1, y: 0 },
    hover: { 
        scale: 1.02, 
        y: -80,
        transition: { 
            type: "spring" as const,
            stiffness: 400,
            damping: 10
        }
    }
};

export const tourOverlayVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { 
        opacity: 1, 
        scale: 1,
        transition: { 
            type: "spring" as const,
            stiffness: 300,
            damping: 25
        }
    }
};

export const tourButtonVariants = (delay: number) => ({
    hidden: { y: -20, opacity: 0 },
    visible: { 
        y: 0, 
        opacity: 1,
        transition: { 
            type: "spring" as const,
            stiffness: 300,
            damping: 20,
            delay
        }
    }
});

// Micro-interaction animations
export const microHoverVariants: Variants = {
    rest: { scale: 1 },
    hover: { 
        scale: 1.05,
        transition: { 
            type: "spring" as const,
            stiffness: 400,
            damping: 10
        }
    }
};

export const microTapVariants: Variants = {
    rest: { scale: 1 },
    tap: { 
        scale: 0.95,
        transition: { 
            type: "spring" as const,
            stiffness: 600,
            damping: 15
        }
    }
};

// Discount Section Animations
export const discountContainerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.12,
            delayChildren: 0.15
        }
    }
};

export const discountLeftContentVariants: Variants = {
    hidden: { 
        opacity: 0, 
        x: -60 
    },
    visible: { 
        opacity: 1, 
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 80,
            damping: 20
        }
    }
};

export const discountBoxVariants: Variants = {
    hidden: { 
        opacity: 0, 
        scale: 0.8,
        rotate: -10
    },
    visible: { 
        opacity: 1, 
        scale: 1,
        rotate: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 15
        }
    }
};

export const discountTimerVariants = (index: number): Variants => ({
    hidden: { 
        opacity: 0, 
        scale: 0.7 
    },
    visible: { 
        opacity: 1, 
        scale: 1,
        transition: {
            delay: index * 0.1,
            type: "spring" as const,
            stiffness: 100,
            damping: 12
        }
    }
});

export const discountSwiperVariants: Variants = {
    hidden: { 
        opacity: 0, 
        x: 80 
    },
    visible: { 
        opacity: 1, 
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 80,
            damping: 20
        }
    }
};

// Interactive hover animations for discount elements
export const discountHoverVariants: Variants = {
    rest: { scale: 1, rotate: 0 },
    hover: { 
        scale: 1.1, 
        rotate: 5,
        boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        transition: { 
            type: "spring" as const,
            stiffness: 300,
            damping: 20
        }
    }
};

export const timerHoverVariants: Variants = {
    rest: { scale: 1, rotate: 0 },
    hover: { 
        scale: 1.15, 
        rotate: 360,
        boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        transition: { 
            type: "spring" as const,
            stiffness: 300,
            damping: 20,
            rotate: { duration: 0.6 }
        }
    }
};

// Improved Tour Card Animations (without scale)
export const tourCardHoverVariants: Variants = {
    rest: { y: 0, boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)" },
    hover: { 
        y: -12,
        boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.15), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        transition: { 
            type: "spring" as const,
            stiffness: 300,
            damping: 25
        }
    }
};

// Smooth overlay animation
export const tourOverlaySmoothVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { 
        opacity: 1, 
        y: 0,
        transition: { 
            type: "spring" as const,
            stiffness: 400,
            damping: 30
        }
    }
};

// Smooth button animations
export const tourButtonSmoothVariants = (delay: number) => ({
    hidden: { y: -15, opacity: 0 },
    visible: { 
        y: 0, 
        opacity: 1,
        transition: { 
            type: "spring" as const,
            stiffness: 400,
            damping: 25,
            delay
        }
    }
});

// Premium Tour List Animations
export const tourListContainerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05,
            delayChildren: 0.05
        }
    }
};

export const tourListItemVariants: Variants = {
    hidden: { 
        opacity: 0, 
        y: 20,
        scale: 0.98
    },
    visible: { 
        opacity: 1, 
        y: 0,
        scale: 1,
        transition: {
            type: "spring" as const,
            stiffness: 120,
            damping: 25,
            duration: 0.4
        }
    }
};

// View Type Transition Animation - Premium Flip Effect
export const viewTransitionVariants: Variants = {
    hidden: { 
        opacity: 0,
        rotateY: -90,
        scale: 0.8,
        y: 30
    },
    visible: { 
        opacity: 1,
        rotateY: 0,
        scale: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 150,
            damping: 20,
            duration: 0.7
        }
    }
};

// Alternative: Morphing Transition
export const morphTransitionVariants: Variants = {
    hidden: { 
        opacity: 0,
        scaleX: 0.3,
        scaleY: 0.8,
        y: 40,
        rotateX: -15
    },
    visible: { 
        opacity: 1,
        scaleX: 1,
        scaleY: 1,
        y: 0,
        rotateX: 0,
        transition: {
            type: "spring" as const,
            stiffness: 120,
            damping: 18,
            duration: 0.8
        }
    }
};

// Alternative: Wave Transition
export const waveTransitionVariants: Variants = {
    hidden: { 
        opacity: 0,
        y: 50,
        rotateZ: -5,
        scale: 0.85
    },
    visible: { 
        opacity: 1,
        y: 0,
        rotateZ: 0,
        scale: 1,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 15,
            duration: 0.9
        }
    }
};

// Filter Panel Animation
export const filterPanelVariants: Variants = {
    hidden: { 
        opacity: 0, 
        x: -30 
    },
    visible: { 
        opacity: 1, 
        x: 0,
        transition: {
            type: "spring" as const,
            stiffness: 100,
            damping: 20,
            duration: 0.6
        }
    }
};

// Search Results Header Animation
export const searchHeaderVariants: Variants = {
    hidden: { 
        opacity: 0, 
        y: -20 
    },
    visible: { 
        opacity: 1, 
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 150,
            damping: 20,
            duration: 0.5
        }
    }
};

// Pagination Animation
export const paginationVariants: Variants = {
    hidden: { 
        opacity: 0, 
        y: 20 
    },
    visible: { 
        opacity: 1, 
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 120,
            damping: 20,
            duration: 0.4
        }
    }
};

// ============================================
// PROFILE MENU / DROPDOWN ANIMATIONS
// ============================================
// Akıcı, modern dropdown/menu animasyonları
// Headless UI MenuItems ile uyumlu

/**
 * Profile Menu Dropdown Container Animation
 * Yumuşak scale + fade + slide kombinasyonu
 * Origin point'ten (sağ üst) açılma efekti
 */
export const profileMenuVariants: Variants = {
    hidden: { 
        opacity: 0, 
        scale: 0.85,
        y: -8,
        filter: "blur(4px)"
    },
    visible: { 
        opacity: 1, 
        scale: 1,
        y: 0,
        filter: "blur(0px)",
        transition: {
            type: "spring" as const,
            stiffness: 400,
            damping: 30,
            mass: 0.8,
            duration: 0.35
        }
    },
    exit: {
        opacity: 0,
        scale: 0.9,
        y: -4,
        filter: "blur(2px)",
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 1, 1]
        }
    }
};

/**
 * Profile Menu Item Animation
 * Stagger efekti ile sırayla görünme
 */
export const profileMenuItemVariants = (index: number = 0): Variants => ({
    hidden: { 
        opacity: 0, 
        x: -12,
        scale: 0.95
    },
    visible: { 
        opacity: 1, 
        x: 0,
        scale: 1,
        transition: {
            type: "spring" as const,
            stiffness: 500,
            damping: 35,
            delay: index * 0.05 + 0.1,
            duration: 0.3
        }
    },
    exit: {
        opacity: 0,
        x: -8,
        scale: 0.98,
        transition: {
            duration: 0.15
        }
    }
});

/**
 * Login Form Container Animation (Modal içinde)
 * Yumuşak fade + scale kombinasyonu
 */
export const loginFormContainerVariants: Variants = {
    hidden: { 
        opacity: 0, 
        scale: 0.96,
        y: 8
    },
    visible: { 
        opacity: 1, 
        scale: 1,
        y: 0,
        transition: {
            type: "spring" as const,
            stiffness: 400,
            damping: 28,
            mass: 0.9,
            duration: 0.4,
            staggerChildren: 0.08,
            delayChildren: 0.1
        }
    },
    exit: {
        opacity: 0,
        scale: 0.95,
        y: 4,
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 1, 1]
        }
    }
};

/**
 * Login Form Item Animation
 * Form içindeki input ve button'lar için
 */
export const loginFormItemVariants = (index: number = 0): Variants => ({
    hidden: { 
        opacity: 0, 
        y: 10,
        scale: 0.98
    },
    visible: { 
        opacity: 1, 
        y: 0,
        scale: 1,
        transition: {
            type: "spring" as const,
            stiffness: 500,
            damping: 30,
            delay: index * 0.06,
            duration: 0.3
        }
    }
});

/**
 * Menu Header Animation (Hi! [Name] bölümü)
 * Özel vurgu animasyonu
 */
export const menuHeaderVariants: Variants = {
    hidden: { 
        opacity: 0, 
        y: -4,
        scale: 0.98
    },
    visible: { 
        opacity: 1, 
        y: 0,
        scale: 1,
        transition: {
            type: "spring" as const,
            stiffness: 400,
            damping: 25,
            duration: 0.35
        }
    }
};

/**
 * Menu Divider Animation
 * İnce çizgi animasyonu
 */
export const menuDividerVariants: Variants = {
    hidden: { 
        opacity: 0, 
        scaleX: 0
    },
    visible: { 
        opacity: 1, 
        scaleX: 1,
        transition: {
            type: "spring" as const,
            stiffness: 300,
            damping: 20,
            duration: 0.3,
            delay: 0.15
        }
    }
};

